import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_STOPS_LIST,
  CREATE_STOPS,
  EDIT_STOPS_BY_ID,
  LOAD_STOPS_BY_ID,
  DELETE_STOPS,
} from './actions';
import { STOPS_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  stopsListMeta: {},
  loadingStopsList: false,
  stopsList: [],
  loadingCurrentStops: false,
  currentStops: {},
  loadingCreateStops: false,
  loadingEditStopsById: false,
  loadingDeleteStops: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(STOPS_MODULE + LOAD_STOPS_LIST, 'stopsList', 'loadingStopsList'),
  ...updateLoadParameterReducer(STOPS_MODULE + LOAD_STOPS_BY_ID, 'currentStops', 'loadingCurrentStops', {}),
  ...createOperationStateReducer(STOPS_MODULE + CREATE_STOPS, 'loadingCreateStops'),
  ...createOperationStateReducer(STOPS_MODULE + EDIT_STOPS_BY_ID, 'loadingEditStopsById'),
  ...createOperationStateReducer(STOPS_MODULE + DELETE_STOPS, 'loadingDeleteStops'),
}, initialState);

export default reducer;

export const getStopsData = createSelector(
  [state => state[STOPS_MODULE]],
  state => {
    const {
      stopsListMeta,
      loadingStopsList,
      stopsList,
      loadingCurrentStops,
      currentStops,
      loadingCreateStops,
      loadingEditStopsById,
      loadingDeleteStops,
    } = state;
    return {
      stopsListMeta,
      loadingStopsList,
      stopsList,
      loadingCurrentStops,
      currentStops,
      loadingCreateStops,
      loadingEditStopsById,
      loadingDeleteStops,
    };
  },
);
